import React from 'react';
import localization from 'localization/Localization';
import { formatString } from 'util/Utils';
import { UserProvider } from 'components/contexts/UserContext';
import AppServices from 'services/AppServices';

const AppLauncher = () => {
	const session = AppServices.loginService.getSession();
	const user = UserProvider.getData();

	if(session === undefined) {
		return null
	}

	const href = formatString(
		'ptmomentum://?access_token={0}&refresh_token={1}&identifier={2}',
		session.accessToken || '',
		session.refreshToken || '',
		user.id || ''
	)

	return (
		<a className='store-badge' id='momentum-launcher' href={href}>
			<img id='momentum-launcher-icon' src='/assets/images/site-logo-192.png' alt='Launch Physiotools Trainer' />
			<span id='momentum-launcher-text'>{localization.get('banner_launch_momentum')}</span>
		</a>
	)
}

export default AppLauncher;